// extracted by mini-css-extract-plugin
export default {"wrapper":"Sidebar_wrapper__JRAQE","sidebar":"Sidebar_sidebar__G0aTe","item":"Sidebar_item__FpnZf","active":"Sidebar_active__gvIZm"};